import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "joined-template" }


export default /*@__PURE__*/_defineComponent({
  __name: 'CJoinedTemplate',
  props: {
    isMasters: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["game-overview-board", _ctx.isMasters ? 'masters-deco' : ''])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})